<template>
    <div class="Home">
        <Card class="card-container">
            <div :class="[type=='forgotPassword'? 'cardWrapper mt-2 red' : 'cardWrapper mt-2']">
                <div class="text-center mb-1 text-bold">Untuk mengubah Nomor Telepon Masukan kode OTP yang dikirim ke nomor {{ phoneNumber.slice(0, phoneNumber.length - 3).replace('+62', '0') }}xxx</div>
                <p @click="resendVerif()" :class="`resend-verif ${timer.minutes === 0 && timer.seconds === 0 ? 'enable-resend' : ''}`">Kirim ulang {{ timer.minutes > 9 ? timer.minutes : '0' +timer.minutes }} : {{ timer.seconds > 9 ? timer.seconds : '0'+ timer.seconds }} </p>
                <form @submit.prevent="sendVerification">
                    <div class="inputWrapper">
                        <input type="text" v-for="(key, i) in activationKeyFields" :key="i"
                            onkeydown="javascript: return event.keyCode === 8 ||event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                            :data-length="key.length" :data-index="i" :ref="`input-${i}`" v-model="key.value"
                            maxlength="1" @keyup="handleActivationInput($event)" />
                    </div>
                    <button
                       :disabled="activationKey.length !== 4" :class="[type==='forgotPassword'? 'btn-fill red rounded mt-2' : 'btn-fill blue rounded mt-2']">Verifikasi</button>

                </form>
                <button @click="$router.go(-1)" class="btnBackBottom btn-outline blue rounded">Kembali</button>
            </div>
        </Card>
    <Loader v-if="isLoad" />
    </div>
</template>

<script>
import Card from '@/components/cardCenter.vue'
// import Btn from '@/components/backBtn.vue'
import Loader from '@/components/loader.vue'
import encoded from '@/mixins/encodeForm'
import axios from 'axios'
export default {
  components: {
    Card,
    // Btn,
    Loader
  },
  mixins: [encoded],
  props: {
    phoneNumber: {
      required: true,
      Type: String
    },
    password: {
      required: true,
      Type: String
    }
  },
  data () {
    return {
      numb: '',
      type: '',
      pass: '',
      isLoad: false,
      form: null,
      activationKeyFields: [{
        length: 1,
        value: ''
      },
      {
        length: 1,
        value: ''
      },
      {
        length: 1,
        value: ''
      },
      {
        length: 1,
        value: ''
      }

      ],
      timer: {
        minutes: 0,
        seconds: 0
      },
      resetTimer: false,
      interval: null
    }
  },
  mounted () {
    this.verifikasi()
    // this.numb = this.$route.params.number
    // this.type = this.$route.params.type
    // this.pass = this.$cookie.getCookie('password')
    // if (!this.pass) {
    //     this.logger('password tidak ada')
    //     this.$router.push('/')
    // }
  },
  unmounted () {
    clearInterval(this.interval)
  },
  methods: {
    async resendVerif () {
      if (this.timer !== 0) {

      } else {
        this.verifikasi()
        this.resetTimer = false
        this.timer = 30
      }
    },
    async verifikasi () {
      const params = new FormData()
      params.append('newmobilenumber', this.phoneNumber)
      params.append('password', this.password)
      const config = {
        headers: { authorization: `Bearer ${this.$cookie.getCookie('token')}` }
      }
      try {
        const res = await axios.post('auth/edit/otpnewmobilenumber', params, config)
        localStorage.setItem('otpChangeNumber', res.data.data.expired_datetime)
        localStorage.setItem('activityID', res.data.data.user_activity_id)
        this.interval = setInterval(() => {
          this.calculateTimeLeft(res.data.data.expired_datetime)
        }, 1000)
      } catch (err) {
        if (err?.response?.data?.message?.includes('Mohon tunggu')) {
          const time = localStorage.getItem('otpChangeNumber')
          this.interval = setInterval(() => {
            this.calculateTimeLeft(time)
          }, 100)
          return
        }
        this.resetTimer = true
        this.$emit('onsuccessotp', true)

        this.toast({ type: err.response?.data?.status, message: err.response?.data?.message ?? err.response?.data?.internal_message })
        if (
          err.response.data.code === 4016 ||
          err.response.data.code === 4015 ||
          err.response.data.code === 4006
        ) {
          this.$emit('onsuccessotp', true)
        }
        if (err.response) {
          this.timer = 0
          this.activationKeyFields = [{
            length: 1,
            value: ''
          },
          {
            length: 1,
            value: ''
          },
          {
            length: 1,
            value: ''
          },
          {
            length: 1,
            value: ''
          }
          ]
        }
      }
    },
    async sendVerification (e) {
      e.preventDefault()

      this.isLoad = true
      const config = {
        headers: { authorization: `Bearer ${this.$cookie.getCookie('token')}` }
      }
      const params = new FormData()
      params.append('otp', this.activationKey)
      params.append('newmobilenumber', this.phoneNumber)
      params.append('password', this.password)
      params.append('user_activity_id', localStorage.getItem('activityID'))

      try {
        const res = await axios.post('auth/edit/verifynewmobilenumber', params, config)
        this.$cookie.setCookie('number', this.phoneNumber)
        this.alertNormal(res.data.data)
        this.$emit('onsuccessotp', true)
      } catch (err) {
        this.toast({ type: err.response?.data?.status, message: err.response?.data?.message || err.response?.data?.internal_message })
      }
      this.isLoad = false
    },
    handleActivationInput (e) {
      // Grab input's value
      const value = e.target.value
      // Grab data-index value
      const index = parseInt(e.target.dataset.index)
      // Grab data-length value
      const maxlength = parseInt(e.target.dataset.length)

      // this.logger(index, 'index input',this.activationKeyFields[index].value.length, maxlength)
      if (this.activationKeyFields[index].value.length > maxlength) {
        e.preventDefault()
        this.activationKeyFields[index].value = value.slice(0, 1)
        try {
          this.$refs[`input-${parseInt(index + 1)}`].focus()
        } catch (e) {}
        return
      }

      // Shift focus to next input field if max length reached

      if (value.length >= maxlength) {
        if (typeof this.activationKeyFields[index + 1] === 'undefined') {
          e.preventDefault()
          if (this.activationKeyFields[2].value !== '') {
            if (e.keyCode === 13) {
              this.verifikasi()
            }
          }
          return
        }
        // this.logger(this.$refs[`input-${parseInt(index + 1)}`], 'ref')

        this.$refs[`input-${parseInt(index + 1)}`].classList.add('mystyle')
        this.$refs[`input-${parseInt(index + 1)}`].focus()
        e.preventDefault()
      } else {
        if (typeof this.activationKeyFields[index - 1] === 'undefined') {
          e.preventDefault()
          return
        }
        this.$refs[`input-${parseInt(index - 1)}`].focus()
        e.preventDefault()
      }
      // this.logger(e)
    },
    calculateTimeLeft (endTime) {
      const difference = +new Date(endTime) - +new Date()

      if (difference > 0) {
        this.timer.minutes = Math.floor((difference / 1000 / 60) % 60)
        this.timer.seconds = Math.floor((difference / 1000) % 60)
      }
    }
  },
  computed: {
    activationKey () {
      let value = ''
      for (const field of this.activationKeyFields) {
        value += field.value
      }
      return value
    }
  }
}
</script>

<style lang="scss" scoped>
    @import '../assets/scss/Layout/home.scss';

    button {
        cursor: pointer;
    }

    .Home {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        bottom: 0;
        z-index: 100;
        left: 0;
        right: 0;
        overflow-y: hidden !important;
        background-color: rgba(0,0,0, 0.3);
        .cardWrapper {
            .inputWrapper {
                display: flex;
                padding: 0 40px;
                justify-content: space-around;

                input {
                    width: 55px;
                    height: 55px;
                    border-radius: 10px;
                    border: none;
                    background-color: #dee3f0;
                    text-align: center;

                }
            }

            &.red {
                input {
                    background-color: #fddddd;
                }
            }
        }
    }
    .resend-verif {
        text-align: center;
    }
    .enable-resend {
        cursor: pointer;
        color: $blue;
        font-weight: 600;
    }
</style>
